var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo.isSupportUser
      ? _c("div", { staticClass: "tile is-parent pl-1" }, [
          _c("div", { staticClass: "tile is-child box" }, [
            _c(
              "section",
              { staticClass: "container" },
              [
                _c("div", [
                  _c("div", { staticClass: "field" }, [
                    _c("p", { staticClass: "control has-icons-left" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.filterKeyword,
                            expression: "filterKeyword",
                          },
                        ],
                        staticClass: "input is-primary",
                        attrs: {
                          id: "filter",
                          type: "text",
                          placeholder: "Filter",
                        },
                        domProps: { value: _vm.filterKeyword },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.filterKeyword = $event.target.value
                          },
                        },
                      }),
                      _vm._m(0),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "is-flex is-justify-content-right pt-3" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "button is-primary",
                        on: { click: _vm.enableV2 },
                      },
                      [_vm._v("Enable All")]
                    ),
                  ]
                ),
                _c("hr"),
                _vm._l(_vm.filteredPermissionRecords, function (p, idx) {
                  return _c("div", { key: idx, staticClass: "item" }, [
                    _c("div", { staticClass: "columns" }, [
                      _c("div", { staticClass: "column is-2" }, [
                        _c("h2", { staticClass: "subtitle is-6" }, [
                          _vm._v(" " + _vm._s(p.name)),
                        ]),
                      ]),
                      _c("div", { staticClass: "column is-narrow" }, [
                        _c("div", { staticClass: "field has-addons" }, [
                          _vm._m(1, true),
                          _c("p", { staticClass: "control" }, [
                            _c("span", { staticClass: "select is-small" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: p.version,
                                      expression: "p.version",
                                    },
                                  ],
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          p,
                                          "version",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      function ($event) {
                                        return _vm.updateVersion(
                                          p,
                                          $event.target.value
                                        )
                                      },
                                    ],
                                  },
                                },
                                _vm._l(p.versions, function (val, key) {
                                  return _c(
                                    "option",
                                    { key: key, domProps: { value: key } },
                                    [_vm._v(_vm._s(key))]
                                  )
                                }),
                                0
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "column" },
                        _vm._l(p.versions[p.version], function (c, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "field has-addons" },
                            [
                              _c("p", { staticClass: "control" }, [
                                _c(
                                  "button",
                                  { staticClass: "button is-static is-small" },
                                  [_vm._v(" " + _vm._s(c.route) + " ")]
                                ),
                              ]),
                              _c("p", { staticClass: "control is-expanded" }, [
                                _c("input", {
                                  staticClass: "input is-small",
                                  attrs: { readonly: "" },
                                  domProps: { value: c.link },
                                }),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ]),
        ])
      : _c("div", { staticClass: "is-flex is-justify-content-center pt-5" }, [
          _c(
            "div",
            {
              staticClass:
                "notification is-danger is-flex is-justify-content-center is-size-4",
              staticStyle: { width: "50%" },
            },
            [_vm._v(" You do not have permissions on this page ")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-left" }, [
      _c("i", { staticClass: "mdi mdi-magnify mdi-20px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "control" }, [
      _c("a", { staticClass: "button is-static is-small" }, [
        _vm._v(" Version "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }